/* eslint-disable */
import axios from '@/services/axios'

export default {
    listFirstClass(search, source) {
        return axios.get("/brandpin/getFirstClasses", { params: search, cancelToken: source.token });
    },
    listBrand(search, source) {
        return axios.post("/brandpin/getBrands", search, { cancelToken: source.token });
    },
    getBrandPinDataBar(search, source) {
        return axios.post("/brandpin/getBrandPinDataBar", search, { cancelToken: source.token });
    },
    getBrandPinDataBarExp(search, source) {
        return axios.post("/brandpin/getBrandPinDataBarExp", search, { cancelToken: source.token });
    },
};
